import React, { useEffect, useState } from "react";
import "./UserReviewPage.css";
import Navbar from "../components/Navbar";
import Fotter from "../components/Fotter";
import { Link, useParams } from "react-router-dom";
import axios from "axios";
import { BASE_URL } from "../Pages/Config";
import BuyerName from "../components/BuyerNameRewview";
import BuyerNamechar from "../components/BuyerNamechar";
import "../components/UserReviewInfo.css";
import { formatDistanceToNow } from "date-fns";
import { enUS } from "date-fns/locale"; // You can customize this

// ⭐ Format date helper
const formatDate = (dateString) => {
  if (!dateString) return "Date not available";

  // Parse UTC safely
  let date;
  if (dateString.endsWith("Z")) {
    date = new Date(dateString); // ISO UTC
  } else {
    date = new Date(dateString.replace(" ", "T") + "Z"); // convert to ISO UTC
  }

  const days = ["SUN", "MON", "TUE", "WED", "THU", "FRI", "SAT"];
  const months = [
    "JAN",
    "FEB",
    "MAR",
    "APR",
    "MAY",
    "JUN",
    "JUL",
    "AUG",
    "SEP",
    "OCT",
    "NOV",
    "DEC",
  ];

  return ` ${days[date.getUTCDay()]} ${String(date.getUTCDate()).padStart(
    2,
    "0"
  )} ${months[date.getUTCMonth()]} ${date.getUTCFullYear()}`;
};

// ⭐ Star Rating Component
function StarRating({ smile_count }) {
  let stars = "";
  let lineClass = "";
  let img = "";

  // 1–10 White Line

  if (smile_count >= 0 && smile_count <= 10) {
    stars = "";
    lineClass = "stage1";
    img = "../stars/white.png";
  }

  // 11–20 Silver Line
  else if (smile_count >= 11 && smile_count <= 20) {
    stars = "";
    lineClass = "stage2";
    img = "../stars/silver.png";
  }

  // 21–30 Golden Line
  else if (smile_count >= 21 && smile_count <= 30) {
    stars = "";
    lineClass = "stage3";
    img = "../stars/gold.png";
  }

  // 31–60 White + 1 white star
  else if (smile_count >= 31 && smile_count <= 60) {
    stars = "☆";
    lineClass = "stage1";
    img = "../stars/13.png";
  }

  // 61–90 Silver + 1 silver star
  else if (smile_count >= 61 && smile_count <= 90) {
    stars = "★";
    lineClass = "stage2";
    img = "../stars/12.png";
  }

  // 91–120 Gold + 1 gold star
  else if (smile_count >= 91 && smile_count <= 120) {
    stars = "★";
    lineClass = "stage3";
    img = "../stars/11.png";
  }

  // 121–150 White + 2 white stars
  else if (smile_count >= 121 && smile_count <= 150) {
    stars = "☆☆";
    lineClass = "stage1";
    img = "../stars/21.png";
  }

  // 151–180 Silver + 2 silver stars
  else if (smile_count >= 151 && smile_count <= 180) {
    stars = "★★";
    lineClass = "stage2";
    img = "../stars/22.png";
  }

  // 181–210 Gold + 2 gold stars
  else if (smile_count >= 181 && smile_count <= 210) {
    stars = "★★";
    lineClass = "stage3";
    img = "../stars/24.png";
  }

  // 211–300 White + 3 white stars
  else if (smile_count >= 211 && smile_count <= 300) {
    stars = "☆☆☆";
    lineClass = "stage1";
    img = "../stars/33.png";
  }

  // 301–400 White + 4 white stars
  else if (smile_count >= 301 && smile_count <= 400) {
    stars = "☆☆☆☆";
    lineClass = "stage1";
    img = "../stars/white.png";
  }

  // 1001–1500 Silver + 5 silver stars
  else if (smile_count >= 401 && smile_count <= 500) {
    stars = "★★★★";
    lineClass = "stage2";
    img = "../stars/55.png";
  }

  // 1501–2000 Gold + 6 gold stars
  else if (smile_count >= 501 && smile_count <= 1000) {
    stars = "★★★★";
    lineClass = "stage3";
    img = "../stars/6.png";
  }

  // 2001–2500 White + 7 white stars
  else if (smile_count >= 1001 && smile_count <= 2000) {
    stars = "☆☆☆☆☆";
    lineClass = "stage1";
    img = "../stars/7.png";
  }

  // 2501–3000 Silver + 8 silver stars
  else if (smile_count >= 2001 && smile_count <= 3000) {
    stars = "★★★★★";
    lineClass = "stage2";
    img = "../stars/8.png";
  }

  // 3001–3500 Gold + 9 gold stars
  else if (smile_count >= 3001 && smile_count <= 4000) {
    img = "../stars/9.png";
  }

  // 3501–3800 White + 6 white stars
  else if (smile_count >= 4001 && smile_count <= 5000) {
    stars = "☆☆☆☆☆☆";
    lineClass = "stage1";
    img = "../stars/10.png";
  }

  const starArray = stars.split("");

  const size = 50;

  return (
    <div
      style={{
        display: "flex", // ⭐ stays inline with text
        position: "relative",
        width: size,
        height: size,
        verticalAlign: "middle",
        alignItems: "end",
      }}
    >
      <img src={img} />
    </div>
  );
}

// ⭐ Review Card

// ⭐ Main Component
export default function SellerReview() {
  const { id } = useParams();
  const [user, setUser] = useState(null);
  const [originalReviews, setOriginalReviews] = useState([]);
  const [reviews, setReviews] = useState([]);
  const [rating, setRating] = useState([]);
  const [sortOption, setSortOption] = useState("newest");
  const [smileCount, setSmileCount] = useState({ smile_count: 0 });

  useEffect(() => {
    const fetchUserAndReviews = async () => {
      try {
        const res = await axios.get(
          `${BASE_URL}/get_review.php?id=${id}&t=${Date.now()}`
        );
        if (res.data.success) {
          //console.log("user_data", res.data.user);
          setUser(res.data.user);
          setOriginalReviews(res.data.reviews);
          setRating(res.data.rating_stats);
          setReviews(res.data.reviews); // default
          setSmileCount(Number(res.data.rating_stats?.smiling_count) || 0);
        } else {
          console.error("User or reviews not found");
        }
      } catch (error) {
        console.error("API error:", error);
      }
    };

    fetchUserAndReviews();
  }, [id]);

  //  console.log("reviews ", reviews);

  // ⭐ Sort handler
  useEffect(() => {
    let sorted = [...originalReviews];
    if (sortOption === "newest") {
      sorted.sort((a, b) => new Date(b.created_at) - new Date(a.created_at));
    } else if (sortOption === "oldest") {
      sorted.sort((a, b) => new Date(a.created_at) - new Date(b.created_at));
    } else if (sortOption === "highest") {
      sorted.sort((a, b) => Number(b.rating_score) - Number(a.rating_score));
    }
    setReviews(sorted);
  }, [sortOption, originalReviews]);

  return (
    <>
      <Navbar />

      {/* Breadcrumb */}
      <div className="page-info">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <div className="info">
                <Link to="/">
                  <p>HOME</p>
                </Link>
                <span>/</span>
                <p>About buyer</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* User Review Section */}
      <div className="user-review-page">
        <div className="user-header" style={{ position: "relative" }}>
          <div className="profile-pic">
            {user?.image ? (
              <img
                src={`${BASE_URL}/${user.image}`}
                alt="Profile"
                style={{ width: "60px", height: "60px", borderRadius: "50%" }}
              />
            ) : (
              <div
                id="fallbackInitial"
                style={{
                  display: "flex",

                  width: "60px",
                  height: "60px",
                  backgroundColor: "#ccc",
                  alignItems: "center",
                  justifyContent: "center",
                  fontWeight: "900",
                  fontSize: "35px",
                  color: "rgb(106 95 95)",
                  textTransform: "uppercase",
                }}
              >
                {user?.name?.[0]}
              </div>
            )}
          </div>

          <div className="user-details">
            <div className="user-name">{user?.name || "Loading..."}</div>
            <div className="user-rating">
              <span className="rating-box">{rating.smiling_percentage}%</span>
              <StarRating smile_count={smileCount} />
              <span className="reviews">({reviews.length} Reviews)</span>
              <span className="rating-info">
                <Link to="/reviewdetail" className="premium-link">
                  Know more about rating !
                </Link>
              </span>
            </div>
            <span className="rating-info2">
              <Link to="/reviewdetail" className="premium-link">
                Know more about rating !
              </Link>
            </span>
          </div>
          <span
            style={{
              fontSize: "9px",
              display: "flex",
              gap: "5px",
              color: "#5c5c5c",
              position: "absolute",
              top: "15px",
              right: "15px",
            }}
          >
            Member since{" "}
            {user?.created_date
              ? formatDistanceToNow(
                  (() => {
                    const d = user.created_date;
                    if (d.endsWith("Z")) return new Date(d); // ISO UTC
                    return new Date(d.replace(" ", "T") + "Z"); // "YYYY-MM-DD HH:MM:SS" → UTC
                  })(),
                  {
                    addSuffix: true,
                    locale: enUS,
                  }
                ).replace("about ", "")
              : "Date not available"}
          </span>
        </div>

        {/* Filter Sort Dropdown */}
        <div className="sort-section">
          <select
            className="sort-dropdown"
            value={sortOption}
            onChange={(e) => setSortOption(e.target.value)}
          >
            <option value="newest">Sort by newest review</option>
            <option value="oldest">Sort by oldest review</option>
            <option value="highest">Sort by highest rating</option>
          </select>
        </div>

        {/* Reviews List */}
        <div className="reviews-list">
          {reviews.length > 0 ? (
            reviews.map((r, index) => (
              <div
                key={index}
                className="review-card"
                style={{ position: "relative" }}
              >
                <div
                  className="review-date"
                  style={{ fontWeight: "600", fontSize: "12px" }}
                >
                  Rated at :
                  <span style={{ fontSize: "10px", fontWeight: "500" }}>
                    {formatDate(r.created_at)}
                  </span>
                </div>
                <div className="review-header">
                  <div className="avatar">
                    <BuyerNamechar buyerId={r.sender_id} />
                  </div>
                  <div className="user-info">
                    <div className="username">
                      <b style={{ fontWeight: "600", fontSize: "13px" }}>
                        Product Name : <span>{r.product_name}</span>
                      </b>
                      <p
                        style={{
                          display: "flex",
                          alignItems: "center",
                          fontSize: "13px",
                          gap: "5px",
                          margin: "0px",
                        }}
                      >
                        {" "}
                        Rated by : <BuyerName buyerId={r.sender_id} />
                      </p>
                    </div>
                    <div className="rating">
                      {/* <StarRating
                        smiling_percentage={rating.smiling_percentage}
                      />{" "}
                      <span style={{ fontWeight: "700", fontSize: "10px" }}>
                        {r.rating_score == 1 ? "Sad" : ""}
                        {r.rating_score == 2 ? "Natural" : ""}
                        {r.rating_score == 3 ? "Happy" : ""}
                      </span> */}
                    </div>
                  </div>
                  <div className="emoji">
                    {r.rating_score == 1 ? "😞" : ""}
                    {r.rating_score == 2 ? "🙂" : ""}
                    {r.rating_score == 3 ? "😄" : ""}
                  </div>
                </div>
                <p className="review-text">{r.message}</p>
              </div>
            ))
          ) : (
            <p style={{ textAlign: "center" }}>No reviews found.</p>
          )}
        </div>
      </div>
      <br />
      <Fotter />
    </>
  );
}
